var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"mb-0",attrs:{"show":"","variant":"info","data-cy":"billing-permission-notice"}},[_c('strong',[_vm._v("An account admin needs to finish this step.")]),_vm._v(" Payment, bank and verification details can only be set up by an admin of this account. Ask an admin to complete the setup, then check back here. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }